module.exports = __webpack_public_path__ + "static/media/current_status.82c89b36.png";